
const UPDATE_INTERVAL = 1000

const state = {
    _interval: -1
}

const getters = {}

const mutations = {}

const actions = {
    start({ dispatch }) {
        // start our interval
        if (state._interval >= 0) clearInterval(state._interval)
        // state._interval = setInterval(function () { dispatch('cycle') }, UPDATE_INTERVAL)
        // state._interval = setInterval(() => {
        //     dispatch('diligenceCheck')
        // }, 20000)
        // dispatch start to each store  
        // dispatch('company/start', null, {root: true})
        // dispatch('people/start', null, { root: true })
        dispatch('accountPlans/start', null, { root: true })
        dispatch('dashboardCoordinates/start', null, { root: true })
        dispatch('team/start', null, { root: true })
        dispatch('role/start', null, { root: true })
        dispatch('investment/start', null, { root: true })
        dispatch('file/start', null, { root: true })
        dispatch('diligence/start', null, { root: true })
        dispatch('diligence_stage/start', null, { root: true })
        dispatch('transaction_type/start', null, { root: true })
        dispatch('newsFeed/start', null, { root: true })
        dispatch('suggestions/start', null, { root: true })
        dispatch('referrer/start', null, { root: true })
        dispatch('charts/start', null, { root: true })
        dispatch('contacts/start', null, { root: true })
        dispatch('lpAllocations/start', null, { root: true })
        dispatch('rounds/start', null, { root: true })
        setTimeout(() => {
            dispatch('portfolio/start', null, { root: true })
        }, 1000)
        // dispatch('user/start', null, { root: true })
        // dispatch('workspace/start', null, { root: true })


    },
    shutdown({ dispatch }) {
        if (state._interval >= 0) clearInterval(state._interval)
        state._interval = -1
        // do everything we need to do on exit/stop
        dispatch('user/stop', null, { root: true })
        dispatch('file/stop', null, { root: true })
        dispatch('portfolio/stop', null, { root: true })
        dispatch('people/stop', null, { root: true })
        dispatch('attachment/stop', null, { root: true })
        dispatch('offering/stop', null, { root: true })
        dispatch('investment/stop', null, { root: true })
        dispatch('todo/stop', null, { root: true })
        dispatch('workspace/stop', null, { root: true })
        dispatch('team/stop', null, { root: true })
        dispatch('role/stop', null, { root: true })
        dispatch('diligence/stop', null, { root: true })
        dispatch('diligence_stage/stop', null, { root: true })
        dispatch('transaction_type/stop', null, { root: true })
        dispatch('newsFeed/stop', null, { root: true })
        dispatch('suggestions/stop', null, { root: true })
        dispatch('referrer/stop', null, { root: true })
        dispatch('notifications/stop', null, { root: true })
        dispatch('accountPlans/stop', null, { root: true })
        dispatch('workspacePlans/stop', null, { root: true })
        dispatch('contacts/stop', null, { root: true })
        dispatch('lpAllocations/stop', null, { root: true })
        dispatch('dashboardCoordinates/stop', null, { root: true })
        dispatch('rounds/stop', null, { root: true })
    },
    restart({ dispatch }) {
        dispatch('shutdown')
        dispatch('start')
    },
    cycle({ dispatch }) {
        // send out cycle dispatches
        dispatch('user/cycle', null, { root: true })
        //   dispatch('company/cycle', null, { root: true })
        dispatch('portfolio/cycle', null, { root: true })
        //        
        //       dispatch('attachment/cycle', null, { root: true })
    },
    diligenceCheck({ dispatch }) {
        dispatch('diligence/start', null, { root: true })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}